import { Tabs } from 'antd';
import { JobOptionSvc } from 'domains/jobconfigDomain';
import { useEffect, useState } from 'react';
import './CommonOneofFormTabs.less';

const { TabPane } = Tabs;

interface Props {
  value?: number;
  onChange?: (value: number) => void;
  list?: JobOptionSvc[];
  disabled?: boolean;
}

const CommonOneofFormTabs = (props: Props) => {
  const { value, onChange, list, disabled } = props;

  const [curValue, setCurValue] = useState(value);

  useEffect(() => {
    // controlled mode
    if (value !== undefined) {
      setCurValue(value);
    }
  }, [value]);

  return (
    <>
      <Tabs
        activeKey={curValue + ''}
        animated={false}
        className="commonOneofFormTabs-default"
        onChange={(val: string) => {
          // if (value === undefined) {
          //   // uncontroled mode
          setCurValue(+val);
          // }
          if (onChange) {
            onChange(+val);
          }
        }}
      >
        {list?.map((item) => (
          <TabPane
            disabled={disabled}
            tab={item.name}
            key={item.id + ''}
          ></TabPane>
        ))}
      </Tabs>
    </>
  );
};

export default CommonOneofFormTabs;
